import { logToDataLayer } from './LogHelper';

export const priceMatrixSearch = (loggingData, translatedMessage) => {
  let error = '';
  if (translatedMessage && translatedMessage.severity !== 'information') {
    error = `${translatedMessage?.errorCode}:${translatedMessage?.program}:${translatedMessage?.systemId}`;
  }

  if (loggingData) {
    logToDataLayer({
      travelAction: loggingData.action,
      travelResortCode: loggingData.resortCode,
      travelHotelCode: loggingData.hotelCode,
      hotelWVId: loggingData.hotelWvId, // Denna ska vara utan travel framför.
      travelDepartureYear: loggingData.departureDateYear,
      travelDepartureMonth: loggingData.departureDateMonth,
      travelDepartureDay: loggingData.departureDateDay,
      travelDestinationCode: loggingData.destinationCode,
      travelDuration: loggingData.duration,
      travelType: loggingData.travelType,
      travelDepartureCode: loggingData.departureCode,
      travelCountryCode: loggingData.countryCode,
      travelPax: loggingData.numberOfPassengers,
      travelAdults: loggingData.numberOfAdults,
      travelAges: loggingData.passengerAges,
      travelChildren: loggingData.numberOfChildren,
      travelAlternativeResult: loggingData.alternativeResult,
      travelHits: loggingData.numberOfHits,
      travelHotelProvider: loggingData.travelHotelProvider,
      travelPrice: loggingData.travelPrice,
      event: loggingData.event,
      ...(error && { error }),
    });
  }

  if (error) {
    logToDataLayer({
      error,
      event: 'CA error',
    });
  }
};

export const showPriceMatrixSpecialOffer = () => {
  logToDataLayer({
    priceMatrixComponents: 'PriceMatrixSpecialOffer_View',
    event: 'PriceMatrixComponents',
  });
};

export const priceMatrixOnRequestLinkClicked = () => {
  logToDataLayer({
    priceMatrixComponents: 'PriceMatrixOnRequest_Click',
    event: 'PriceMatrixComponents',
  });
  return true;
};

export const showPriceMatrixOnRequestLink = () => {
  let logPhrase = null;
  logPhrase = 'PriceMatrixOnRequest_View';
  logToDataLayer({
    priceMatrixComponents: logPhrase,
    event: 'PriceMatrixComponents',
  });
};

export const specialOfferIconPriceMatrixOrHotelListClicked = () => {
  logToDataLayer({
    priceMatrixComponents: 'PriceMatrixSpecialOffer_Click',
    event: 'PriceMatrixComponents',
  });
};

export const priceMatrixRoomGroupClick = () => {
  logToDataLayer({
    priceMatrixComponents: 'PriceMatrixRoomPrice_Click',
    event: 'PriceMatrixComponents',
  });
};
